import { QRCodeSVG } from 'qrcode.react';
import styles from './qrCodePopup.module.css';
import { Modal } from '@pvh-components/modal';
import { Button } from '@pvh-components/button';
import QRCodeHeader from './QRCodeHeader';
import { ReactComponent as CloseIcon } from '../../assets/icons/closeIcon.svg';
import { toKebabCase } from '../../utils/casing';
import { WithTestId } from '../../types';

export interface QRCodePopupProps extends WithTestId {
  url: string;
  isOpen: boolean;
  popupHeading: string;
  popupText: string;
  closeButtonLabel: string;

  onRequestClose: () => void;
}

const QRCodePopup = ({
  url,
  isOpen,
  popupHeading,
  popupText,
  closeButtonLabel,
  onRequestClose,
  dataTestIdPrefix,
}: QRCodePopupProps) => {
  return (
    <Modal
      displayLogo={true}
      isOpen={isOpen}
      headerComponent={
        <QRCodeHeader popupHeading={popupHeading} popupText={popupText} />
      }
      onRequestClose={onRequestClose}
      size="small"
      buttonComponent={
        <CloseIcon
          data-testid={toKebabCase(
            dataTestIdPrefix,
            'qrPopup',
            'close',
            'top',
            'button'
          )}
        />
      }
      dataTestIdPrefix={toKebabCase(dataTestIdPrefix, 'qrPopup')}
    >
      <div className={styles.qrCodeCentered}>
        <QRCodeSVG
          value={url}
          fgColor="#00174F"
          className={styles.qrCode}
          size={214}
        />
        <Button
          variant="secondary"
          fullWidth={true}
          onClick={onRequestClose}
          dataTestIdPrefix={toKebabCase(
            dataTestIdPrefix,
            'qrPopup',
            'close',
            'bottom'
          )}
        >
          {closeButtonLabel}
        </Button>
      </div>
    </Modal>
  );
};

export default QRCodePopup;
